// test292
(292 && 0);
